export const LANGUAGES_SELECT_VALUES = {
  ru: 'RU — Русский',
  ruShort: 'RU',
  en: 'EN — English',
  enShort: 'EN',
  zh: 'ZH — 中国人',
  zhShort: 'ZH',
  ka: 'KA — ქართული',
  kaShort: 'KA',
  tr: 'TR — Türkçe',
  trShort: 'TR',
  tg: 'TG — Тоҷикӣ',
  tgShort: 'TG',
};

export const LOCALES = {
  RU: 'ru',
  EN: 'en',
  ZH: 'zh',
  KA: 'ka',
  TR: 'tr',
  TG: 'tg',
  AM: 'am',
} as const;
